import {
  ThemeProvider,
  ErrorBoundary,
  VersionProvider,
  LanguageProvider,
  SnackBarProvider,
  LocalizationProvider,
  SnowSettingsProvider,
} from 'providers';
import App from './App';
import store from 'store/store';
import { StrictMode } from 'react';
import { reportWebVitals } from 'utils';
import { MyWindow } from 'react-app-env';
import { CssBaseline } from '@mui/material';
import { LicenseInfo } from '@mui/x-license';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';

// Mui License Setting
declare const window: MyWindow;
LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY || window.config.REACT_APP_MUI_LICENSE_KEY);

// Creating Root
const rootElement = document.getElementById('app-root') as HTMLElement;
const root = createRoot(rootElement);

// Render App
root.render(
  <StrictMode>
    <ErrorBoundary>
      <VersionProvider>
        <LanguageProvider>
          <SnowSettingsProvider>
            <ThemeProvider>
              <SnackBarProvider>
                <ReduxProvider store={store}>
                  <LocalizationProvider>
                    <CssBaseline />
                    <App />
                  </LocalizationProvider>
                </ReduxProvider>
              </SnackBarProvider>
            </ThemeProvider>
          </SnowSettingsProvider>
        </LanguageProvider>
      </VersionProvider>
    </ErrorBoundary>
  </StrictMode>
);

reportWebVitals();
